import styled from 'styled-components';
import { Flex } from '@ipc/ipc-components';
import homeDiv from '../../../images/errorBoundaryImage.svg';
import { BlueNavy } from '../../../elements/Colors';

export const StyledFlex = styled(Flex)`
  ${({ theme }) => ({
    color: BlueNavy,
    fontFamily: theme.fonts.title,
  })}

  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 590px;
  height: calc(100vh - 100px);
  padding: 1rem;
  background: url(${homeDiv}) white no-repeat bottom;
`;

export const StyledTitle = styled.p`
  ${({ theme }) => ({
    fontWeight: theme.fontWeights.bold,
    lineHeight: '3',
    fontSize: '2rem',
  })}
  margin-bottom: 0;
  margin-top: 0;
`;
export const StyledSubTitle = styled.p`
  lineHeight: 2;
  fontSize: 1.5rem;
  margin-bottom: 0;
  margin-top: 0;
`;
